import Request from '@/utils/request'
// 获取发票抬头
export function getInvoiceTotal(param) {
  return Request.get('/invoice/getInvoiceTotal', param)
}

// 新增修改发票抬头
export function updateInvoiceTotal(data) {
  return Request.post('/invoice/updateInvoiceTotal', data)
}

// 查询金额信息
export function getTotalAmount(param) {
  return Request.get('/invoice/getTotalAmount', param)
}

// 获取发票列表
export function getInvoiceList(data) {
  return Request.post('/invoice/invoiceQuery', data)
}

// 申请开票
export function applyInvoice(data) {
  return Request.post('/invoice/invoiceApplication', data)
}

// 再次申请开票
export function applyInvoiceAgain(data) {
  return Request.post('/invoice/invoiceAgainApplication', data)
}

// 获取业务类型
export function getCoprType(data) {
  return Request.post('/dict', data)
}
